module.exports = __webpack_public_path__ + "static/media/delete-icon.48130b94.svg";